import {Fragment, h} from "preact";
import { C, CF, F, RE } from "../_common/layout";
import './home-page.scss';
import {t} from '../_i18n';
import { useSelector } from "react-redux";
import Comunicados from "../comunicados/comunicados";
import HelpSection from './HelpSection/HelpSection'
import { isSpanishUser } from '../_common/utils/getLang'
import NotEnrolled from './pages/NotEnrolled/NotEnrolled'
import Dashboard from './pages/Dashboard/Dashboard'
import TrialDashboard from './pages/TrialDashboard/TrialDashboard.js'
import {
    STUDENT_TRIAL,
} from '../app/getUserRol'

export function HomePageView (){
    // const student_meta = useSelector(state => state.status.student_meta)
    const { student_meta, student_access} = useSelector(state => ({
        student_meta: state.status.student_meta,
        student_access: state.student_access,
    }));
    return (
        <F className="max-width-1380 home-page">
            {student_access === STUDENT_TRIAL && <TrialDashboard /> || (student_meta.has_ever_enrolled && student_meta.enabled ?  <Dashboard /> : <NotEnrolled />)}
            {/*{student_meta.has_ever_enrolled ?
                     <C className='dashboard'>
                       <Comunicados />
                       {isSpanishUser(student_meta.shop_id) && <HelpSection />}
                     </C>
                 : <NotEnrolled />
             }*/}
        </F>
    )
}
